document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
  }
  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });
});


document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-media-thumb]');
  if (!thumb) return;
  const gallery = thumb.closest('[data-product-gallery]');
  if (!gallery) return;
  const id = thumb.dataset.mediaThumb;
  gallery.querySelectorAll('[data-media-slide]').forEach((slide) => {
    const active = slide.dataset.mediaSlide === id;
    slide.hidden = !active;
    slide.classList.toggle('is-active', active);
    if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
  });
  gallery.querySelectorAll('[data-media-thumb]').forEach((button) => {
    const active = button.dataset.mediaThumb === id;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-selected', String(active));
  });
});
